import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ErrorMessage } from '@hookform/error-message';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import OTPInput from '../ui/forms/fields/otpInput';

import { Button, CircularProgress, TextField, Typography } from '@mui/material';
import { Box, useTheme } from '@mui/system';
import {
  changeSelectedTwoFactorMethod,
  logout,
  resendOTP,
  sendOtpSMS,
  verifyOTP
} from '../../features/auth/auth.slice';
import GeneralButton from '../ui/buttons/generalButton';
import Form from '../ui/forms';
import PrimaryButton from '../ui/buttons/primaryButton';

import { useNavigate } from 'react-router-dom';

const schema = yup.object().shape({
  otp: yup
    .string()
    .min(4, 'OTP must be 4 digits')
    .required('OTP is required. Check your email Inbox or Spam folder.')
});

const OTPVerify = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();

  const userAvailableMethods = useSelector((state) => state.auth.user?.twoFactorAuthType);
  const twoFactorMethod = useSelector((state) => state.auth.selectedTwoFactorMethod);
  const userId = useSelector((state) => state.auth.user.id);
  const smsSending = useSelector((state) => state.auth.sms.smsSending);
  const smsSent = useSelector((state) => state.auth.sms.smsSent);
  const maskedPhoneNumber = useSelector((state) => state.auth.sms.phoneNumber);
  const otpLoading = useSelector((state) => state.auth.otpLoading);

  const [seconds, setSeconds] = useState(180);
  useEffect(() => {
    let countdown = null;
    if (seconds > 0) {
      countdown = setInterval(() => setSeconds(seconds - 1), 1000);
    } else {
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [seconds]);

  let time;
  seconds > 0 ? (time = `(${seconds})`) : (time = '');

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    setFocus,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onSubmit'
  });

  // const otpWatch = watch('otp');
  // useEffect(() => {
  //   if (otpWatch && otpWatch.length === 4) {
  //     handleSubmit(onSubmit)();
  //   }
  // }, [otpWatch]);

  const onSubmit = (data) => {
    dispatch(verifyOTP(data))
      .unwrap()
      .then((response) => {
        if (!response.success) {
          setValue('otp', '');
          setFocus('otp');
        }
      })
      .catch((error) => {
        setValue('otp', '');
        setFocus('otp');
      });
  };

  const handleResend = () => {
    dispatch(resendOTP())
      .unwrap()
      .then(() => {
        setSeconds(60);
      });
  };

  const handleLogout = () => {
    dispatch(logout())
      .unwrap()
      .then(() => {
        navigate('/signin');
      });
  };

  const handleVerifySMS = () => {
    // Update the selected method to SMS
    dispatch(changeSelectedTwoFactorMethod('Phone'));
    dispatch(sendOtpSMS({ userId }));
  };

  return (
    <Box display={'flex'} flexDirection={'row'} width={'100%'} justifyContent={'center'}>
      <Box
        display={'flex'}
        sx={{
          backgroundColor: theme.palette.background.backdrop,
          borderRadius: 10,
          minWidth: '30vw'
        }}
        p={5}
        m={3}
        justifyContent={'center'}
        alignItems={'center'}>
        <Box
          sx={{
            maxWidth: '250px',
            height: '50%'
          }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems={'center'}>
          <Typography variant="h5" textAlign={'center'} mb={3}>
            Two-Factor Authentication
          </Typography>
          {twoFactorMethod === 'Phone' && smsSent ? (
            <Typography variant="p" gutterBottom textAlign={'center'} mb={3}>
              An SMS with your OTP has been sent to {maskedPhoneNumber}. Please enter the OTP below.
            </Typography>
          ) : (
            <Typography variant="p" gutterBottom textAlign={'center'} mb={3}>
              An email with your OTP has been sent to your email address. Please enter the OTP
              below.
            </Typography>
          )}

          <Form>
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
              <OTPInput name="otp" label="OTP" control={control} disabled={otpLoading} />
              <Button
                variant="contained"
                color={'accent'}
                sx={{ color: 'white', my: 2 }}
                onClick={handleSubmit(onSubmit)}>
                {otpLoading ? <CircularProgress size={20} sx={{ mr: 1 }} /> : 'Continue'}
              </Button>
            </Box>
          </Form>

          {/* <Button
            variant="contained"
            color={'accent'}
            sx={{ color: 'white', my: 2 }}
            onClick={handleSubmit(onSubmit)}>
            Continue
          </Button> */}

          <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
            {userAvailableMethods &&
              userAvailableMethods.length > 1 &&
              userAvailableMethods.includes('Phone') &&
              (smsSending ? (
                <CircularProgress size={20} sx={{ mr: 1 }} />
              ) : (
                !smsSent && (
                  <Button size={'sm'} color={'secondary'} onClick={() => handleVerifySMS()}>
                    {`Verify via SMS`}
                  </Button>
                )
              ))}

            {seconds === 0 && <div>|</div>}
            <Button
              size={'sm'}
              disabled={seconds > 0}
              color={'secondary'}
              sx={{ display: seconds > 0 ? 'none' : 'inherit' }}
              onClick={() => handleResend()}>
              {`Resend OTP`}
            </Button>
          </Box>

          <Box
            display="flex"
            flexDirection={'row'}
            justifyContent={'space-around'}
            alignItems={'center'}
            mt={5}>
            <Button size={'small'} variant={'text'} color={'accent'} onClick={() => handleLogout()}>
              Back to Login
            </Button>
          </Box>

          {/* <ErrorMessage errors={errors} name="otp" /> */}
        </Box>
      </Box>
    </Box>
  );
};

export default OTPVerify;
